import { toSorting as _toSorting } from '@studio/js-utils/sorting';
import { parseJson } from '@tryiris-ai/js-types';
import type { T_Maybe } from '@tryiris-ai/js-types';
import type { Sorting } from './types.js';

/**
 * Transforms the specified value to a `Sorting` object.
 *
 * @param value - The value to be transformed.
 * @returns The transformed `Sorting` or `undefined`.
 */
export const toSorting = (value: unknown): T_Maybe<Sorting> =>
  _toSorting<Sorting>(parseJson(value));
